<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99993 0.692231C4.41171 0.692231 0.692233 4.41171 0.692233 8.99992C0.692232 13.5881 4.41171 17.3076 8.99992 17.3076C13.5881 17.3076 17.3076 13.5881 17.3076 8.99992C17.3076 4.41171 13.5881 0.692232 8.99993 0.692231Z"
      fill="#F0783B"
    ></path>
    <path
      d="M5.08372 8.99973L12.9163 8.99973"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
      data-v-7bff318b=""
    ></path>
    <path
      d="M9 5.08345L9 12.916"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin],
};
</script>
